import axios from "axios";
import {
  makeAutoObservable,
  action,
  observable,
  computed,
  runInAction,
} from "mobx";
import { get, eq } from "lodash";
import { API_HOST } from "../constants";
import { clearSessionCookie, getSessionCookie } from "../utils";

export class UserStore {
  isLoggedIn = false;
  userObj = null;

  constructor() {
    makeAutoObservable(this, {
      isLoggedIn: observable,
      userObj: observable,
      logout: action,
      setUserObj: action,
      setloggedIn: action,
      getLoggedIn: computed,
      hasCompletedOnboarding: computed,
    });

    getSessionCookie()
      .then((cookie) => {
        console.log({ cookie });
        if (!eq(cookie, null)) {
          this.isLoggedIn = true;
        }
      })
      .catch((error) => {});
  }

  async logout() {
    clearSessionCookie();

    try {
      await axios.post(`${API_HOST}user/logout`);
    } catch (error) {}

    runInAction(() => {
      this.userObj = null;
      this.isLoggedIn = false;
    });
  }

  async fetchUser() {
    try {
      const cookie = await getSessionCookie();

      const response = await axios.get(`${API_HOST}user/get_user`, {
        headers: {
          Authorization: cookie,
        },
      });
      const { data } = response;
      const user = get(data, "user", "{}");

      runInAction(() => {
        this.userObj = JSON.parse(user);
        console.log(this.userObj);
      });
    } catch (error) {
      const status = get(error, "response.status");
      if (status === 401) {
        clearSessionCookie();
        runInAction(() => {
          this.isLoggedIn = false;
          this.userObj = null;
        });
      }
      console.log(
        "Failed to fetch user due to error ",
        get(error, "response.data.error", error?.message),
      );
    }
  }

  setLoggedIn(loggedIn) {
    this.isLoggedIn = loggedIn;
  }

  get getLoggedIn() {
    return this.isLoggedIn;
  }

  setUserObj(newUserObj) {
    this.userObj = newUserObj;
  }

  get getUserObj() {
    return this.userObj;
  }

  get hasCompletedOnboarding() {
    return (
      this.userObj?.onboardingComplete === true ||
      this.userObj?.isTutorialPassed === 1 ||
      this.userObj?.is_tutorial_passed === 1
    );
  }
}

export default UserStore;
